import { openTimesheetModal } from '../State/timesheetModal'

export default function(id, projectId) {
  return function(dispatch) {
    dispatch(openTimesheetModal({ id: id, projectId: projectId }))
  }
}
